import { TransactionType } from '@/types/wireTypes';
import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const getTransactionApi = async (id: string): Promise<ApiResponseType<TransactionType>> => {
  const uri = `/organization/contracts/${id}/`;

  return authApiService.GET(uri);
};
